import React from "react";
import "./UiIcon.css";

const UI_ICON_SIZE = {
  xs: 8,
  sm: 12,
  md: 15,
  lg: 24,
  xl: 32,
  xxl: 48,
  xxxl: 64,
};

function UiIcon({ icon, className = "", style, onClick, size, alt, disabled = false, ...props }) {
  if (typeof size === "string") {
    size = UI_ICON_SIZE[size] || 12;
  } else {
    size = size || 12;
  }

  if (onClick) {
    function clickHandler(e) {
      if (disabled) return;
      e.preventDefault();
      e.stopPropagation();
      onClick(e);
    }
    return (
      <React.Fragment>
        <img
          src={icon}
          className={`ui-icon ${className} ${disabled ? "ui-icon-disabled" : ""}`}
          style={{ ...style, cursor: disabled ? "not-allowed" : "pointer" }}
          onClick={clickHandler}
          alt={alt}
          width={size + "px"}
          height={size + "px"}
          loading="lazy"
          {...props}
        />
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      <img
        src={icon}
        className={`ui-icon ${className}`}
        style={style}
        alt={alt}
        width={size + "px"}
        height={size + "px"}
        loading="lazy"
        {...props}
      />
    </React.Fragment>
  );
}

export default UiIcon;
export { UI_ICON_SIZE };
